import Axios from "../utils/axios";
import {
  EmailSenderDropdownOption,
  IEmailSenderUsername,
  IEmailSenderUsernameListResponse,
  IEmailSenderUsernameMutationResponse,
} from "../interfaces/models/IEmailSenderUsername";

const axios = new Axios();

function extractErrorMessage(error: unknown, fallback: string): string {
  const anyErr = error as {
    response?: { data?: { message?: string } | string };
    message?: string;
  };
  const data = anyErr?.response?.data;
  if (typeof data === "string" && data.trim()) {
    return data;
  }
  if (data && typeof data === "object" && data.message) {
    return String(data.message);
  }
  if (anyErr?.message) {
    return String(anyErr.message);
  }
  return fallback;
}

export function toSenderDropdownOptions(
  items: IEmailSenderUsername[],
): EmailSenderDropdownOption[] {
  return items.map((item) => ({
    id: item.emailAddress,
    name: item.emailAddress,
    sender: item.displayName || item.username,
    isCustom: !!item.isCustom,
  }));
}

export async function listEmailSenderUsernames(): Promise<IEmailSenderUsernameListResponse> {
  try {
    const response = await axios.Get("emailSenderUsername");
    const data = response?.data ?? response;
    return {
      domainName: String(data?.domainName || "worldservicesgroup.com"),
      notice: data?.notice,
      items: Array.isArray(data?.items) ? data.items : [],
    };
  } catch (error) {
    throw new Error(
      extractErrorMessage(error, "Failed to load from-email senders from Azure."),
    );
  }
}

export async function createEmailSenderUsername(payload: {
  emailAddress?: string;
  username?: string;
  displayName: string;
}): Promise<IEmailSenderUsernameMutationResponse> {
  try {
    const response = await axios.Post("emailSenderUsername", payload);
    const data = response?.data ?? response;
    return {
      notice: data?.notice,
      item: data?.item,
    };
  } catch (error) {
    throw new Error(
      extractErrorMessage(error, "Failed to create custom from email in Azure."),
    );
  }
}

export async function updateEmailSenderUsername(payload: {
  id: string;
  emailAddress?: string;
  username?: string;
  displayName: string;
}): Promise<IEmailSenderUsernameMutationResponse> {
  try {
    const response = await axios.Put("emailSenderUsername", payload);
    const data = response?.data ?? response;
    return {
      notice: data?.notice,
      item: data?.item,
    };
  } catch (error) {
    throw new Error(
      extractErrorMessage(error, "Failed to update custom from email in Azure."),
    );
  }
}

export async function deleteEmailSenderUsername(username: string): Promise<void> {
  try {
    await axios.Delete("emailSenderUsername", username);
  } catch (error) {
    throw new Error(
      extractErrorMessage(error, "Failed to delete custom from email in Azure."),
    );
  }
}
